export default __webpack_public_path__ + "static/media/successSound.286cb861.mp3";